import TelemedicineContext from '../../../context/telemedicine';
import { createFile } from '../../../services/telemedicine-file';
import TrackUtils from '../../../utils/track';
import ActionsBar from '../ActionsBar';

import { showErrorToast, showSuccessToast } from '@amigoapp/doca-react';
import get from 'lodash.get';
import { useCallback, useContext, useRef, useState } from 'react';
import Video from 'twilio-video';

const TwilioActionsBarContainer = ({ room, previewTracks, devices }) => {
	const fileInputRef = useRef();
	const { telemedicine } = useContext(TelemedicineContext);
	const [currentDevice, setCurrentDevice] = useState(0);
	const [isAudioEnabled, setIsAudioEnabled] = useState(true);
	const [isVideoEnabled, setIsVideoEnabled] = useState(true);
	const [isSubmittingFile, setIsSubmittingFile] = useState(false);

	const onAudioClick = useCallback(_ => {
		const tracks = get(room, 'localParticipant.audioTracks');

		if (room) {
			tracks.forEach(audioTrack => isAudioEnabled ? audioTrack.track.disable() : audioTrack.track.enable());
		}

		isAudioEnabled
			? previewTracks?.[0].disable()
			: previewTracks?.[0].enable();

		setIsAudioEnabled(!isAudioEnabled);
	}, [room, isAudioEnabled, previewTracks]);

	const onVideoClick = useCallback(_ => {
		const tracks = get(room, 'localParticipant.videoTracks');

		if (room) {
			tracks.forEach(videoTrack => isVideoEnabled ? videoTrack.track.disable() : videoTrack.track.enable());
		}

		isVideoEnabled
			? previewTracks?.[1].disable()
			: previewTracks?.[1].enable();

		setIsVideoEnabled(!isVideoEnabled);
	}, [room, isVideoEnabled, previewTracks]);

	const onSwitchCameraClick = useCallback(async () => {
		let newDevice = 0;
		const localParticipant = room.localParticipant;

		if (devices.length <= 1) {
			return;
		}

		if ((currentDevice + 1) < devices.length) {
			newDevice = currentDevice + 1;
		} else {
			newDevice = 0;
		}

		const patientMediaContainer = document.getElementById('patient-tracks');
		const currentTracks = Array.from(localParticipant.videoTracks.values()).map(preview => preview.track);

		localParticipant.unpublishTracks(currentTracks);
		TrackUtils.detachTracks(currentTracks);
		currentTracks.map(track => track.stop());

		const localTracks = await Video.createLocalVideoTrack({
			deviceId: { exact: devices[newDevice] }
		});

		localParticipant.publishTrack(localTracks);
		TrackUtils.attachTracks([localTracks], patientMediaContainer);

		setCurrentDevice(newDevice);

		setTimeout(() => {
			const videoElement = document.querySelector('#patient-tracks video');

			videoElement.style.objectFit = null;
			videoElement.style.objectFit = 'cover';
		}, 400);
	}, [devices, room, currentDevice]);

	const onSelectFiles = useCallback(async event => {
		setIsSubmittingFile(true);

		const { data } = await createFile(event.target.files);

		if (data) {
			showSuccessToast('Documento enviado com sucesso.');
			window.socket.emit('telemedicine:file-sent', {
				room_id: telemedicine.id,
				user_id: telemedicine.user_id
			});
		} else {
			showErrorToast('Não foi possível criar o documento.');
		}

		setIsSubmittingFile(false);
	}, [telemedicine]);

	return (
		<ActionsBar
			fileInputRef={fileInputRef}
			isAudioEnabled={isAudioEnabled}
			isSubmittingFile={isSubmittingFile}
			isSwitchDeviceEnabled={devices?.length > 1}
			isVideoEnabled={isVideoEnabled}
			onAudioClick={onAudioClick}
			onSelectFiles={onSelectFiles}
			onSwitchCameraClick={onSwitchCameraClick}
			onVideoClick={onVideoClick}
		/>
	);
};

export default TwilioActionsBarContainer;
